import {callURL} from './call';
import messageShow from "./messageShow";
import {signerURL} from "../url";
import {push} from "connected-react-router";
import {VALIDATE_ROUTE} from "../components/Root/routes";
import language from "../languages/language";

const forgot= (formValues) => async (dispatch,getState) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            dispatch(push(VALIDATE_ROUTE + '?userName='+ formValues.name));
            dispatch(messageShow({message: language[getState().auth.language].forgotMessage.replace('{0}',formValues.name), type: 'success'}));
        }
        else
            dispatch(messageShow({message: result[1].error, type: 'error'}));
    }
    dispatch(callURL(signerURL,"rest/UserService/forgotPassword",formValues,onResult));
};
export default forgot;